'use strict';
const Actions = require('../actions');
const Button = require('../../../../components/form/button.jsx');
const ControlGroup = require('../../../../components/form/control-group.jsx');
const PropTypes = require('prop-types');
const React = require('react');
const ReactHelmet = require('react-helmet');
const ReactRouter = require('react-router-dom');
const Spinner = require('../../../../components/form/spinner.jsx');
const Store = require('./store');
const TextControl = require('../../../../components/form/text-control.jsx');
const Classnames = require('classnames');
const Helmet = ReactHelmet.Helmet;
const Link = ReactRouter.Link;
// import ToastrContainer from 'react-toastr-basic'
// import { ToastSuccess, ToastDanger } from 'react-toastr-basic'


const propTypes = {
    match: PropTypes.object
};

const { passwordStrength } = require('../../../../helpers/password-strength');


class ResetPage extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
        this.state = Object.assign({ password: '' }, Store.getState());
    }

    componentDidMount() {

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.password) {
            this.input.password.focus();
        }
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        let newState = Store.getState();
        if (newState.error) {
            // ToastDanger(newState.error)
        }

        if (newState.success) {
            // ToastSuccess('Yes!! Your new password has been set.');

            setTimeout(() => {
                Actions.clearSuccess();
                setTimeout(() => {
                    this.props.history.push({
                        pathname: '/login',
                    });
                });

            }, 3000)

        }

        this.setState(newState);
    }

    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        let dataToPost = {
            phone: this.props.match.params.phone,
            username: this.props.match.params.username,
            key: this.props.match.params.key && decodeURIComponent(this.props.match.params.key),
            password: this.input.password.value
        };

        if (!['good', 'strong'].includes(this.state.scoreInWords)) {
            return window.notify('error', 'Password is not strong enough. Please use more letters and special symbols.');
        }

        Actions.reset(dataToPost, (err) => {
            if (err) {
                window.notify('error', err.message);
                setTimeout(() => {
                    Actions.clearSuccess();
                    // GO TO LOGIN.
                    this.props.history.push({
                        pathname: '/login/forgot',
                    });
                }, 3000);
            } else {
                window.notify('success', `הסיסמה עודכנה! נא התחבר.`);
                setTimeout(() => {
                    Actions.clearSuccess();
                    // GO TO LOGIN.
                    this.props.history.push({
                        pathname: '/login',
                    });
                }, 3000);
            }



        });
    }

    passwordFieldChanged(event) {
        event.preventDefault();
        event.stopPropagation();

        let value = this.input.password.value;
        let { score, scoreInWords } = passwordStrength(value);

        this.setState({ password: value, score, scoreInWords })
    };

    render() {

        const alerts = [];

        if (this.state.success) {
            alerts.push(<div key="success">
                <div className="alert alert-success">
                    Your password has been reset. Please login to confirm.
                </div>
                <Link to="/login" className="btn btn-link">Back to login</Link>
            </div>);
        }

        if (this.state.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.state.error}
            </div>);
        }

        return (
            <section className="container">
                <Helmet>
                    <title>Sign in</title>
                </Helmet>
                <img src="/public/media/background-image.jpg" className="background-full-image" />
                <div className="container center-flex-container">
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="logo-wrapper animated fadeInDown">
                            <img
                                className="login-logo"
                                src="/public/media/logo.png"
                            />
                        </div>
                        <div className={`owl ${this.state.focus ? 'password' : ''}`}>
                            <div className="hand" />
                            <div className="hand hand-r" />
                            <div className="arms">
                                <div className="arm" />
                                <div className="arm arm-r" />
                            </div>
                        </div>
                        <div className="form">
                            <div className="control">
                                <label htmlFor="password" className="fa fa-asterisk" />
                                <input id="password" placeholder="New password"
                                       ref={(c) => (this.input.password = c)}
                                       onChange={this.passwordFieldChanged.bind(this)}
                                       type="password"
                                       name="_password"
                                       onBlur={() => this.setState({ focus: false })}
                                       onFocus={() => this.setState({ focus: true })} />
                                <div className="password-progress-wrapper">
                                    <div className={Classnames('password-progress', this.state.scoreInWords)}
                                         style={{ width: `${this.state.score}%` }}></div>

                                </div>

                            </div>
                            <div className="control hidden">
                                <label htmlFor="phone" className="fa fa-phone" />
                                <input id="phone"
                                       disabled={true}
                                       value={this.props.match.params.phone}
                                       ref={(c) => (this.input.phone = c)}
                                       placeholder="Phone" type="text" />
                            </div>
                            <div className="control hidden">
                                <label htmlFor="username" className="fa fa-user" />
                                <input id="username"
                                       disabled={true}
                                       value={this.props.match.params.username}
                                       ref={(c) => (this.input.username = c)}
                                       placeholder="Username" type="text" />
                            </div>
                            <div className="control hidden">
                                <label htmlFor="key" className="fa fa-envelope" />
                                <input id="key"
                                       name="_key"
                                       disabled={true}
                                       value={this.props.match.params.key}
                                       ref={(c) => (this.input.key = c)}
                                       placeholder="Phone" type="text" />
                            </div>

                            <div className="control">
                                <Button
                                    type="submit"
                                    inputClasses={{ 'submit-login-button': true }}
                                    disabled={this.state.loading}>

                                    RESET PASSWORD
                                    <Spinner space="left" show={this.state.loading} />
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
                {/*<ToastrContainer />*/}
            </section>
        );
    }
}

ResetPage.propTypes = propTypes;


module.exports = ResetPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/reset/index.jsx